import { atom } from "recoil";

export const tenantIdAtom = atom<string | null>({
  key: "tenantIdAtom",
  default: null,
});

export const isPrivateTenantCheckedAtom = atom<boolean>({
  key: "isPrivateTenantCheckedAtom",
  default: false,
});
